import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { Booking } from '../../bookings/entities/Booking.js';
import { MartinusTemporaryActions } from '../../MartinusTemporaryPolicy.js';
import { abacOperationMiddleware } from '../../permissions/middlewares/abacOperationMiddleware.js';
import { checkAbacOnViewedUserMiddleware } from '../../permissions/middlewares/checkAbacOnViewedUserMiddleware.js';
import { UserDetailsActions } from '../../users/details/UserDetailsPolicy.js';
import { resolveSubscribeGroupHistoryBookings } from '../server/resolver/resolveSubscribeGroupHistoryBookings.js';
import { resolveSubscribeUserHistoryRelevantItems } from '../server/resolver/resolveSubscribeUserHistoryRelevantItems.js';

/**
 * Some collections and data in the database is completly unused now.
 * This query returns a list of IDs of these collections for a given person ID so we can still track this legacy data
 */
const subscribeUserHistoryRelevantItems = registerSubscription({
  operationName: 'subscribeUserHistoryRelevantItems',
  type: () => [ID],
  params: [{ type: () => ID, name: 'personID' }],
  middlewares: [checkAbacOnViewedUserMiddleware(UserDetailsActions.VIEW_TIMELINE, 'personID')],
  resolve: resolveSubscribeUserHistoryRelevantItems,
});

/**
 * The bookings a group's history covers: every booking the group ever had, also the deleted and moved-away ones,
 * each with the person it belongs to.
 */
const subscribeGroupHistoryBookings = registerSubscription({
  operationName: 'subscribeGroupHistoryBookings',
  type: () => [Booking],
  params: [{ type: () => ID, name: 'groupID' }],
  middlewares: [abacOperationMiddleware(MartinusTemporaryActions.GROUPS_TIMELINE)],
  resolve: resolveSubscribeGroupHistoryBookings,
});

export const HistoryAPI = {
  subscribeUserRelevant: subscribeUserHistoryRelevantItems,
  subscribeGroupBookings: subscribeGroupHistoryBookings,
};
